export const getSelectorListStyle = ({ selectorMode, gridColumnCount, gap }) => {
  if (selectorMode === 'grid') {
    return {
      display: 'grid',
      gridTemplateColumns: `repeat(${Math.max(Number(gridColumnCount) || 1, 1)}, minmax(0, 1fr))`,
      gap,
      height: '100%',
      minHeight: 0,
      width: '100%',
      minWidth: 0,
      overflow: 'hidden',
    };
  }

  return {
    display: 'flex',
    flex: '1 1 0',
    gap,
    height: '100%',
    minHeight: 0,
    minWidth: 0,
    overflow: 'hidden',
  };
};
